export default __webpack_public_path__ + "static/media/gcp.3438de13.png";